<template>
  <b-overlay :show="loading" opacity="0.99">
    <h6 class="text-center title-pages border" v-if="items.length > 0">
      VENDA DA EMPRESA PARA O RESIDENTE
    </h6>
    <div class="row" v-for="(item, key) in items" :key="key">
      <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0 pb-0"></div>
      <div class="col-xl-10 col-lg-8 col-md-10 col-sm-9 col-12 pt-0 pb-0">
        DATA DA VENDA {{ moment(item.date).format("DD/MM/YYYY") }}
      </div>
      <div class="col-xl-1 col-lg-2 col-md-12 col-sm-12 col-12 pt-0 pb-0"></div>
      <div
        class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 d-flex align-items-center justify-content-center"
      >
        <div>
          <b-form-checkbox
            size="md"
            :id="`stock-sale-checkbox-${key}`"
            v-model="item.checked"
            :name="`stock-sale-checkbox-${key}`"
            @input="handleChangeCheckbox"
          >
            LANÇAR?
          </b-form-checkbox>
          <div class="text-center">
            <p v-if="item.checked" class="c-success">SIM</p>
            <p v-if="!item.checked" class="c-danger">NÃO</p>
          </div>
        </div>
      </div>
      <div class="col-xl-10 col-lg-8 col-md-10 col-sm-9 col-12 pt-0 pb-0">
        <div class="row">
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 input-form-required"
          >
            <input
              placeholder="Descrição"
              type="text"
              v-model="item.description"
              class="form-control"
            />
          </div>
          <div class="col-md-2 input-form-required">
            <select v-model="item.spent_or_gain" disabled class="form-control">
              <option value="CREDITO">CRÉDITO</option>
            </select>
          </div>
          <div
            class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 input-form-required"
          >
            <input
              disabled
              placeholder="Valor*"
              type="text"
              class="form-control c-success"
              v-model="item.value"
            />
          </div>
          <div
            class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pt-0 pb-0 vue-treeselect-required"
          >
            <treeselect
              :options="finance_configuration_category"
              placeholder="SELECIONE..."
              v-model="item.finance_configuration_category_id"
              noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
            />
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 pt-0 pb-0 col-12">
            <vs-select
              autocomplete
              style="width: 100%"
              v-model="item.finance_configuration_profit_cost_center_id"
            >
              <vs-select-item :value="null" text="Centro de custo/lucro..." />
              <vs-select-item
                v-for="profit_cost_center in finance_configuration_profit_cost_center"
                :key="profit_cost_center.id"
                :value="profit_cost_center.id"
                :text="profit_cost_center.description"
              />
            </vs-select>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
            <vs-select
              disabled
              style="width: 100%"
              v-model="item.finance_client_id"
            >
              <vs-select-item :value="null" text="Cliente..." />
              <vs-select-item
                v-for="client in finance_client"
                :key="client.id"
                :value="client.id"
                :text="`${client.resident_id ? '(RESIDENTE) - ' : ''}${
                  client.name
                }`"
              />
            </vs-select>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
            <vs-select
              autocomplete
              style="width: 100%"
              v-model="item.finance_configuration_payment_methods_id"
            >
              <vs-select-item :value="null" text="Forma de pagamento..." />
              <vs-select-item
                v-for="payment_method in finance_configuration_payment_methods"
                :key="payment_method.id"
                :value="payment_method.id"
                :text="payment_method.description"
              />
            </vs-select>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
            <v-select
              hide-details
              v-model="item.finance_configuration_tag_ids"
              :items="finance_configuration_tag"
              chips
              label="Tags"
              multiple
              solo
              item-text="description"
              item-value="id"
            />
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pb-0">
            <vs-select
              autocomplete
              style="width: 100%"
              v-model="item.cost_type"
            >
              <vs-select-item :value="null" text="Tipo de custo..." />
              <vs-select-item
                v-for="cost_type in cost_types"
                :key="cost_type.value"
                :value="cost_type.value"
                :text="cost_type.description"
              />
            </vs-select>
          </div>
          <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12 pb-0">
            <vs-select
              autocomplete
              style="width: 100%"
              v-model="item.cost_appropriation"
            >
              <vs-select-item :value="null" text="Apropriação de custo..." />
              <vs-select-item
                v-for="cost_appropriation in cost_appropriations"
                :key="cost_appropriation.value"
                :value="cost_appropriation.value"
                :text="cost_appropriation.description"
              />
            </vs-select>
          </div>
        </div>
      </div>
      <div class="col-xl-1 col-lg-2 col-md-12 col-sm-12 col-12"></div>
      <div class="col-md-12 pt-0 pb-0"><hr /></div>
    </div>
    <div v-if="data.length > 0" class="text-right mt-2">
      <h1 class="title-pages text-fourteen">
        TOTAL VENDA DA EMPRESA PARA O RESIDENTE: R$
        {{ formatPrice(total_value) }}
      </h1>
    </div>
    <ErrorsMessages :errors="errors" />
  </b-overlay>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import Treeselect from "@riophae/vue-treeselect";

import {
  professionalClassCouncilValue,
  formatReal,
  formatPrice,
} from "../../../../../lib/format";

import moment from "moment";

export default {
  name: "StockSale",

  components: {
    ErrorsMessages,
    Treeselect,
  },

  props: {
    loading: Boolean,
    resident_id: [Number, String],
    data: Array,
    total_value: [Number, String],
    start: String,
    end: String,

    finance_client_id: [Number, String],
    finance_client: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
    finance_configuration_category_id: [Number, String],
  },

  data() {
    return {
      expanded: [],
      selected: [],
      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "MEDICAMENTO", value: "name", sortable: false },
        { text: "GRUPO", value: "stock_group", sortable: false },
        { text: "QTD", value: "amount", sortable: false },
        { text: "LOTE", value: "lot", sortable: false },
        { text: "VALOR", value: "value", sortable: false },
        { text: "TOTAL FINAL", value: "total_value", sortable: false },
      ],

      items: [],

      errors: [],
    };
  },

  watch: {
    data() {
      this.retrieve();
    },

    finance_configuration_category() {
      let financeConfigurationCategoryId = null;
      for (let category of this.finance_configuration_category) {
        if (category.default == 1) {
          financeConfigurationCategoryId = category.id;
        }
      }

      this.items.map((item) =>
        !item.stock_item_finance_configuration_category_id
          ? (item.finance_configuration_category_id =
              financeConfigurationCategoryId)
          : (item.finance_configuration_category_id =
              item.stock_item_finance_configuration_category_id)
      );
    },
  },

  methods: {
    moment,
    formatReal,
    formatPrice,
    professionalClassCouncilValue,

    handleChangeCheckbox() {
      let { items } = this;

      let checkeds = [];
      for (let item of items) {
        if (item.checked) {
          checkeds.push(item);
        }
      }

      this.$emit("itemsChecked", checkeds);
    },

    retrieve() {
      let { data, finance_client_id, finance_configuration_category_id } = this;

      let items = [];

      for (let item of data) {
        let description;
        if (item.stock_item_type == "MEDICINE") {
          description = `${item.medicine_name}, LOTE: ${item.lot}, ${item.amount} ${item.stock_item_unit_of_measurement_abbreviation}, GRUPO: ${item.stock_group_name}`;
        } else {
          description = `${item.product_name}, LOTE: ${
            item.lot ? item.lot : "NÃO INFORMADO"
          }, ${item.amount} ${
            item.stock_item_unit_of_measurement_abbreviation
          }, GRUPO: ${item.stock_group_name}`;
        }

        items.push({
          id: item.id,
          description,
          value: String(formatReal(item.value)).replace("R$", "").trim(),
          finance_configuration_category_id,
          finance_configuration_profit_cost_center_id: null,
          provider_id: null,
          finance_client_id,
          finance_configuration_payment_methods_id: null,
          finance_configuration_tag_ids: [],
          cost_type: null,
          cost_appropriation: null,
          spent_or_gain: "CREDITO",
          type: "STOCK_SALE",
          date: item.created_at,
          checked: false,
          stock_item_finance_configuration_category_id:
            item.stock_item_finance_configuration_category_id,
        });
      }
      this.items = items;

      let financeConfigurationCategoryId = null;
      for (let category of this.finance_configuration_category) {
        if (category.default == 1) {
          financeConfigurationCategoryId = category.id;
        }
      }

      this.items.map((item) =>
        !item.stock_item_finance_configuration_category_id
          ? (item.finance_configuration_category_id =
              financeConfigurationCategoryId)
          : (item.finance_configuration_category_id =
              item.stock_item_finance_configuration_category_id)
      );

      this.$emit("items", items);
    },
  },
};
</script>